<template>
  <div class="container">
    <div class="search-container">
      <input type="text" v-model="searchInput" @input="eventSearch" />
    </div>

    <div class="box-container">
      <table>
        <tr>
          <th></th>
          <th style="cursor: pointer" @click="selectFilter('name')">
            <div class="switch-container">
              <button
                :class="{'active' : !upcoming && !attendingEvents}"
                @click="upcoming=false; attendingEvents=false"
              >Past</button>
              <button
                :class="{'active' : upcoming && !attendingEvents}"
                @click="upcoming=true; attendingEvents=false"
              >Upcoming</button>
              <button :class="{'active' : attendingEvents}" @click="attendingEvents=true">Attending</button>
            </div>Name
            <span
              v-if="orderBy.field === 'name'"
            >{{orderBy.order == 'asc' ? '&#9650;' : '&#9660;' }}</span>
          </th>

          <th
            style="cursor: pointer;width: 1px;padding-right: 120px;white-space: nowrap;padding-left: 70px;"
            @click="selectFilter('startDate')"
          >
            <span class="only-bm">
              Start Date
              <span
                v-if="orderBy.field === 'startDate'"
              >{{orderBy.order == 'asc' ? '&#9650;' : '&#9660;' }}</span>
            </span>
          </th>

          <th style="cursor: pointer;" @click="selectFilter('endDate')">
            <span class="only-bm">
              End Date
              <span
                v-if="orderBy.field === 'endDate'"
              >{{orderBy.order == 'asc' ? '&#9650;' : '&#9660;' }}</span>
            </span>
          </th>
        </tr>
        <tr v-for="(event, index) in eventsToDisplay" :key="index">
          <td>
            <img
              v-if="upcoming"
              class="add-btn"
              :class="{'attending': event.attending}"
              :src="require(`@/assets/${event.attending ? 'remove' : 'add'}.svg`)"
              @click="event.attending ? removeFromAttending(event.ref) : addToAttending(event.ref)"
            />
          </td>
          <td>
            <a @click="$router.push(`/events/${event.id}`)">{{event.name}}</a>
          </td>

          <td
            style="cursor: pointer;width: 1px;padding-right: 120px;white-space: nowrap;padding-left: 70px;"
          >
            <span
              v-if="event.startDate"
            >{{event.startDate.toDate().getMonth()+1}}/{{event.startDate.toDate().getDate()}}/{{event.startDate.toDate().getFullYear()}}</span>
            <span v-else>TBD</span>
          </td>

          <td>
            <span
              v-if="event.endDate"
            >{{event.endDate.toDate().getMonth()+1}}/{{event.endDate.toDate().getDate()}}/{{event.endDate.toDate().getFullYear()}}</span>
            <span v-else>TBD</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { db } from "../db";
import firebase from "firebase/app";
export default {
  data() {
    return {
      events: [],
      eventsToDisplay: [],
      baseQuery: db.collection("events"),
      currentQuery: null,
      upcoming: true,
      todayTimeStamp: firebase.firestore.Timestamp.fromDate(new Date()),
      orderBy: {
        field: "name",
        order: "asc"
      },
      searchInput: "",
      last: null,
      attendingEvents: false
    };
  },
  created() {
    this.executeQuery();
  },
  methods: {
    queryBuilder() {
      if (this.upcoming) {
        this.currentQuery = this.baseQuery.where(
          "startDate",
          ">",
          this.todayTimeStamp
        );
      } else {
        this.currentQuery = this.baseQuery.where(
          "startDate",
          "<",
          this.todayTimeStamp
        );
      }
    },
    executeQuery() {
      this.queryBuilder();
      this.currentQuery.get().then(snap => {
        this.events = snap.docs.map(doc => {
          let attending = false;

          if (
            this.$store.state.coach.attendingEvents &&
            this.$store.state.coach.attendingEvents.find(
              event => event.path == doc.ref.path
            )
          ) {
            attending = true;
          }

          return {
            ...doc.data(),
            id: doc.id,
            ref: doc.ref,
            attending
          };
        });

        this.last = snap.docs[snap.docs.length - 1];
        this.eventsToDisplay = [...this.events];
        this.sort();
      });
    },
    sort() {
      this.eventsToDisplay.sort((a, b) => {
        let fieldA;
        let fieldB;

        if (this.orderBy.field == "name") {
          fieldA = a.name.toLowerCase();
          fieldB = b.name.toLowerCase();
        } else if (this.orderBy.field == "startDate") {
          fieldA = a.startDate;
          fieldB = b.startDate;
        } else if (this.orderBy.field == "endDate") {
          fieldA = a.endDate;
          fieldB = b.endDate;
        }

        if (this.orderBy.order == "asc") {
          if (fieldA < fieldB) {
            return -1;
          }
          if (fieldA > fieldB) {
            return 1;
          }
        } else if (this.orderBy.order == "desc") {
          if (fieldA > fieldB) {
            return -1;
          }
          if (fieldA < fieldB) {
            return 1;
          }
        }

        return 0;
      });
    },
    loadMore() {
      if (this.last) {
        this.currentQuery
          .startAfter(this.last)
          .get()
          .then(snap => {
            if (snap.empty) {
              alert("no more items to load");
            } else {
              this.last = snap.docs[snap.docs.length - 1];
              const moreEvents = snap.docs.map(doc => {
                return {
                  ...doc.data(),
                  id: doc.id
                };
              });

              this.eventsToDisplay = [...this.eventsToDisplay, ...moreEvents];

              this.sort();
            }
          });
      }
    },
    eventSearch() {
      let filteredArray;

      if (this.searchInput === "") {
        this.eventsToDisplay = [...this.events];
        return;
      }

      filteredArray = this.events.filter(event => {
        return event.name
          .toLowerCase()
          .startsWith(this.searchInput.toLowerCase());
      });
      this.eventsToDisplay = [...filteredArray];
    },
    selectFilter(field) {
      if (this.orderBy.field === field) {
        this.orderBy.order === "asc"
          ? (this.orderBy = { field, order: "desc" })
          : (this.orderBy = { field, order: "asc" });
      } else {
        this.orderBy = { field, order: "asc" };
      }
    },
    addToAttending(eventRef) {
      db.collection("coaches")
        .doc(this.$store.state.coach.id)
        .update({
          attendingEvents: firebase.firestore.FieldValue.arrayUnion(eventRef)
        })
        .then(res => {
          this.$store
            .dispatch("getCoachDoc", this.$store.state.coach.id)
            .then(() => {
              let updatedEvents = this.eventsToDisplay.map(eventToDisplay => {
                let attending = false;
                if (
                  this.$store.state.coach.attendingEvents &&
                  this.$store.state.coach.attendingEvents.find(
                    event => event.path == eventToDisplay.ref.path
                  )
                ) {
                  attending = true;
                }
                return { ...eventToDisplay, attending };
              });
              this.$set(this, "eventsToDisplay", updatedEvents);
            });
        });
    },
    removeFromAttending(eventRef) {
      db.collection("coaches")
        .doc(this.$store.state.coach.id)
        .update({
          attendingEvents: firebase.firestore.FieldValue.arrayRemove(eventRef)
        })
        .then(() => {
          this.$store
            .dispatch("getCoachDoc", this.$store.state.coach.id)
            .then(() => {
              this.$store
                .dispatch("getCoachDoc", this.$store.state.coach.id)
                .then(() => {
                  let updatedEvents = this.eventsToDisplay.map(
                    eventToDisplay => {
                      let attending = false;
                      if (
                        this.$store.state.coach.attendingEvents &&
                        this.$store.state.coach.attendingEvents.find(
                          event => event.path == eventToDisplay.ref.path
                        )
                      ) {
                        attending = true;
                      }
                      return { ...eventToDisplay, attending };
                    }
                  );
                  this.$set(this, "eventsToDisplay", updatedEvents);
                  if (this.attendingEvents)
                    this.eventsToDisplay = [
                      ...this.$store.state.attendingEvents
                    ];
                });
            });
        });
    }
  },
  watch: {
    orderBy() {
      this.sort();
    },
    upcoming() {
      this.executeQuery();
    },
    attendingEvents(value) {
      if (value) {
        this.eventsToDisplay = [...this.$store.state.attendingEvents];
      } else {
        this.executeQuery();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
table tr th:first-child {
  width: 4%;
}
table tr th:nth-child(2) {
  width: 27%;
}

.add-btn {
  height: 16px;
  width: 16px;
  cursor: pointer;
  filter: invert(70%) sepia(0%) saturate(239%) hue-rotate(227deg)
    brightness(89%) contrast(101%);

  &.attending {
    height: 18px;
    width: 18px;
    filter: invert(11%) sepia(93%) saturate(1536%) hue-rotate(186deg)
      brightness(96%) contrast(101%);
  }
}
</style>